import Vue from 'vue';
import App from './App.vue';
import axios from 'axios';

axios.defaults.baseURL = 'https://de1.cantamen.de/casirest/v3';

// axios.defaults.headers.common['X-API-Key'] = 'f552d21c-389d-efcb-3d5b-3df570def064'; // zoom
// axios.defaults.headers.common['X-API-Key'] = 'b7214e7c-852c-73bd-7bd9-f1884f0629bf';  // lue
// axios.defaults.headers.common['X-API-Key'] = '9772256a-4e8a-245b-b7d6-c7f28439a405'; // nes
// axios.defaults.headers.common['X-API-Key'] = '90478869-9b00-dac0-c961-ffbda74708f3'; //sam
axios.defaults.headers.common['X-API-Key'] = '2a512c53-994e-067f-3e1f-eb5289660bbe'; // os

Vue.config.productionTip = false;

new Vue({
	render: h => h(App)
}).$mount('#app');
